import { useState } from 'react'
import { Box, Button, CircularProgress, Typography, useMediaQuery, useTheme } from '@mui/material'
import Swal from 'sweetalert2'

import { startCheckout } from '../../services/api/StripeDataService'
import { SectionPaper } from '../../pages/studio/tabs/analytics/analyticsUi'


export default function ProPromoCard() {
    const theme = useTheme()
    const isMobile = useMediaQuery('(max-width:1050px)')
    const [loading, setLoading] = useState(false)

    const onUpgrade = async () => {
        setLoading(true)
        try {
            await startCheckout('Pro', true)
        } catch {
            setLoading(false)
            Swal.fire({ title: "Can't Proceed to Checkout", text: 'Something went wrong. Please try again later.', icon: 'error' })
        }
    }

    return (
        <SectionPaper sx={{ border: `2px solid ${theme.palette.primary.main}`, bgcolor: 'rgba(255,20,147,0.04)', py: 4 }}>
            <Box sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                textAlign: isMobile ? 'center' : 'left',
                gap: 2,
            }}>
                <Box>
                    <Typography variant="h6" component="h6" sx={{ fontWeight: 600, fontSize: isMobile ? '1.1rem' : '1rem', fontFamily: 'inherit' }}>
                        Ready to grow and monetize? Try Pro for Free
                    </Typography>
                </Box>
                <Button onClick={onUpgrade} variant="contained" disabled={loading}
                    sx={{ flexShrink: 0, textTransform: 'none', borderRadius: '40px', boxShadow: '4px 5px 0px #000', px: 3, py: 1, fontWeight: 500 }}>
                    {loading ? <CircularProgress size={18} color="inherit" /> : 'Get Started'}
                </Button>
            </Box>
            <Typography sx={{ mt: '.8rem', fontSize: '.6rem', color: '#888', textAlign: isMobile ? 'center' : 'right' }}>
                14-day free trial then $8/mo
            </Typography>
        </SectionPaper>
    )
}
